import { Checkbox } from '@shared/ui/checkbox/checkbox';
import { Typography } from '@shared/ui/typography/typography';
import { Button } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const FormBody = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 36px;
`;

export const Title = styled('div')`
    position: relative;
    display: flex;
    width: 100%;
    height: 40px;
    align-items: center;
`;

export const BackButton = styled(Button)`
    position: absolute !important;
    display: block;
    margin: 0;
    top: 0;
    left: 0;
    border: none !important;

    .rf-button__text {
        margin: 0 !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const TitleText = styled(Typography)`
    width: 100%;
    text-align: center;
`;

export const FormBox = styled('form')`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 12px;
`;

export const GroupInputs = styled('div')`
    display: flex;
    gap: 20px;
`;

export const StyledButton = styled(Button)`
    margin-top: 16px !important;
`;

export const StyledCheckbox = styled(Checkbox)`
    margin-top: 8px;
`;

export const Option = styled('div')`
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
`;

export const PreloaderOption = styled(Option)`
    height: 36px;
`;

export const OptionDescriptionWrapper = styled('div')`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;

export const Controls = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 20px;
`;
